export const MountainMark = ({ className = "", id = "mm" }) => (
  <svg viewBox="0 0 120 56" className={className} aria-hidden="true">
    <defs>
      <linearGradient id={`${id}-g`} x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#A9825C" />
        <stop offset="1" stopColor="#E3CBA8" />
      </linearGradient>
    </defs>
    <path
      d="M0 54 L26 26 L36 37 L60 4 L86 34 L94 26 L120 54 L92 54 L86 47 L80 54 L48 54 L54 48 L46 36 L34 48 L38 54 Z"
      fill={`url(#${id}-g)`}
    />
  </svg>
);

export const RidgeLines = ({ className = "" }) => (
  <svg viewBox="0 0 1200 400" className={className} preserveAspectRatio="none" aria-hidden="true" fill="none">
    {[0, 28, 56, 84, 112, 140].map((o, i) => (
      <path
        key={i}
        d={`M0 ${380 - o} L180 ${290 - o} L300 ${330 - o} L520 ${120 - o} L700 ${260 - o} L820 ${200 - o} L1000 ${60 - o} L1200 ${240 - o}`}
        stroke="#C4A277"
        strokeWidth="1"
        opacity={0.45 - i * 0.06}
      />
    ))}
  </svg>
);
